import { render, staticRenderFns } from "./UserProfileItem.vue?vue&type=template&id=701d1f08&"
import script from "./UserProfileItem.vue?vue&type=script&lang=js&"
export * from "./UserProfileItem.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports